import React from 'react';

//import images
import dashboard from "assets/images/dashboard.png";

const WelcomeWidget = () => {
    return (
        <React.Fragment>
            <div className="relative col-span-8 card   bg-slate-900  ">
               
                <div className="relative card-body">
                    <div className="grid items-center grid-cols-8">
                        <div className="col-span-12 lg:col-span-8 2xl:col-span-7">
                            <h5 className="mb-3 font-normal tracking-wide text-slate-200">Welcome Admin</h5>
                            <p className="mb-5 text-slate-400">This dashboard provides a transparent view of gold-based transfer activities. Monitor key metrics, user activity, and transaction statuses in real time.</p>
                         </div>
                        
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default WelcomeWidget;
